"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GeolocationPermissionStatus;
(function (GeolocationPermissionStatus) {
    GeolocationPermissionStatus["GRANTED"] = "granted";
    GeolocationPermissionStatus["DENIED"] = "denied";
    GeolocationPermissionStatus["PROMPT"] = "prompt";
})(GeolocationPermissionStatus = exports.GeolocationPermissionStatus || (exports.GeolocationPermissionStatus = {}));
